import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'

export const PanelsWrapper = styled.div((props) => {
  const { panelsStyle, width } = props
  return `
    display: block;
    width: ${width}px;
    ${stylesIf(Boolean(panelsStyle), panelsStyle)}
  `
})

export const Panel = styled.div((props) => {
  const { width, height } = props
  return `
    position: relative;
    padding: 16px;
    margin: 16px 16px 48px;
    display: inline-block;
    vertical-align: top;
    ${stylesIf(Boolean(width), `width: ${width}px;`)}
    ${stylesIf(Boolean(height), `height: ${height}px;`)}
  `
})

export const PanelHeader = styled.div(
  (props) => `
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 100%;
    font-size: 24px;
  `
)

export const PanelContent = styled.div(
  (props) => `
    position: relative;
    width: 100%;
  `
)
